import { propExistsOnObject, renderColorPicker } from '../utils'
import { WATERFALL_DEFAULT_VALUES } from '../styleConsts'
import { cloneDeep } from 'lodash'
import { ScoopColumn } from '../../../../../ui'
import styleTabStyles from '../StyleTab.module.scss'

export const WaterfallConfig = ({ config, setConfig, chartPreferences }) => {
    const getWaterfallPropValue = (prop) => {
        if (propExistsOnObject(config.styleOverrides.waterfall, prop))
            return config.styleOverrides.waterfall[prop]
        if (propExistsOnObject(chartPreferences.waterfall, prop))
            return chartPreferences.waterfall[prop]
        return WATERFALL_DEFAULT_VALUES[prop]
    }

    const handleLinePropChange = (prop, value) => {
        const newConfig = cloneDeep(config)
        newConfig.styleOverrides.waterfall[prop] = value
        setConfig(newConfig)
    }

    return (
        <ScoopColumn className={styleTabStyles.configContainer}>
            {renderColorPicker('Start Color', getWaterfallPropValue('startColor'), (v) =>
                handleLinePropChange('startColor', v)
            )}
            {renderColorPicker('End Color', getWaterfallPropValue('endColor'), (v) =>
                handleLinePropChange('endColor', v)
            )}
            {renderColorPicker('Up Color', getWaterfallPropValue('upColor'), (v) =>
                handleLinePropChange('upColor', v)
            )}
            {renderColorPicker('Down Color', getWaterfallPropValue('downColor'), (v) =>
                handleLinePropChange('downColor', v)
            )}
        </ScoopColumn>
    )
}
